import * as angular from "angular";
import {IController} from "angular";
import {FulfillmentDialogService} from "../../services/fulfillment-dialogs-service.service";

export class FulfillmentDetailViewCtrl implements IController {

  fulfillment: any;

  /* @ngInject */
  constructor(private fulfillmentDialogService: FulfillmentDialogService, private $log, private $fulfillment) {
  }

  $onInit() {
  }

  onDispatch(fulfillment, stepIds, event) {
    this.fulfillmentDialogService.dispatchStep(fulfillment, stepIds, event)
      .then((newStep) => {

      })
      .catch((error) => {
        this.$log.debug('Failed to dispatch step', error);
      })
  }

  getFulfilment(fulfillmentId) {
    this.$fulfillment(fulfillmentId).$instantGet({expand: true})
      .then((fulfillment) => {
        this.fulfillment = fulfillment;
      })
  }
}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentDetailView', {
    bindings: {
      fulfillment: '<'
    },
    template: require('./fulfillment-detail-view.html').default,
    controller: FulfillmentDetailViewCtrl
  });

